import "../../assets/css/requests/requests.css"

import client from "../../assets/images/clients.svg"
import industry from "../../assets/images/industries.svg"
import status from "../../assets/images/status.svg"
import locationImg from "../../assets/images/location.svg"
import certifications from "../../assets/images/certification.svg"
import sortIcon from "../../assets/images/sort.svg"
import printReport from "../../assets/images/printReport.svg"
import viewProfile from "../../assets/images/viewProfile.svg"
import cvpBadge from "../../assets/images/CVPBagdeTable.png"

import close from "../../assets/images/close.svg"

import { useCallback, useEffect, useMemo, useRef, useState } from "react"
import { useNavigate, useLocation } from "react-router-dom"

import NewRequestModal from "./newRequest.jsx"
import axios from "axios"
import moment from "moment"
import Swal from "sweetalert2"
import { useAuth } from "../../context/auth-user.jsx"
import MassiveStatusUpdateModal from "./massiveStatusUpdateModal.jsx"
import PageSelector from "../pageSelector"

const {
    REACT_APP_URI_SUPPLIERS_DIRECTORY_AND_REQUESTS: URI_SUPPLIERS_REQUESTS,
    REACT_APP_URI_SUPPLIERS_FILTERS: URI_SUPPLIERS_FILTERS,
    REACT_APP_REPORT_SUPPLIER_REQUEST: URI_REPORT_SUPPLIER_REQUEST,
    REACT_APP_URI_UPLOADS: URI_UPLOADS,
} = process.env;

const statusFilterArray = ["New request", "Pre-authorized", "Ready for review", "Review requested"]
const itemsPerPage = 20

export default function Requests({ darkLightMode }) {
    // VARIABLE TO KNOW WHOS IS LOGGED
    const { user } = useAuth()
    const userLogged = user?.selectedProfile

    // Check params
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const paramsCompanyName = searchParams.get("companyName");

    const cleanedUrl = "/home/requests"
    window.history.replaceState(null, "", cleanedUrl);

    const [currentPage, setCurrentPage] = useState(() => {
        const storedPage = sessionStorage.getItem("currentPageRequest")
        return storedPage ? parseInt(storedPage, 10) : 1;
    })

    // VARAIBLE TO CONTROL THE SORT ORDER
    const [order, setOrder] = useState("ASC")
    const [orderBy, setOrderBy] = useState("companyName")

    // VARIABLES TO CONTROL SORT MENU SHOW AND HIDE
    const [showSortMenu, setShowSortMenu] = useState(false)

    // VARIABLE TO MANAGE FILTER AND MOBILE SORT MENU
    const sortMenuRef = useRef(null)
    const filterRef = useRef(null)

    // VARIABLES TO FILTER DATA
    const [clientFilter, setClientFilter] = useState(() => {
        const stored = localStorage.getItem("requestFilters") ?? JSON.stringify({})

        return JSON.parse(stored)?.client ?? []
    })
    const [entityFilter, setEntityFilter] = useState(() => {
        const stored = localStorage.getItem("requestFilters") ?? JSON.stringify({})

        return JSON.parse(stored)?.entity ?? []
    })
    const [industryFilter, setIndustryFilter] = useState(() => {
        const stored = localStorage.getItem("requestFilters") ?? JSON.stringify({})

        return JSON.parse(stored)?.industry ?? []
    })
    const [statusFilter, setStatusFilter] = useState(() => {
        const stored = localStorage.getItem("requestFilters") ?? JSON.stringify({})

        return JSON.parse(stored)?.status ?? []
    })
    const [locationFilter, setLocationFilter] = useState(() => {
        const stored = localStorage.getItem("requestFilters") ?? JSON.stringify({})

        return JSON.parse(stored)?.location ?? []
    })
    const [cvpFilter, setCvpFilter] = useState(() => {
        const stored = localStorage.getItem("requestFilters") ?? JSON.stringify({})

        return JSON.parse(stored)?.cvp ?? false
    })

    // VARIABLES TO KNOW IF THE FILTER IS ON
    const [clientIsFiltered, setClientIsFiltered] = useState(() => {
        const stored = localStorage.getItem("requestFilters") ?? JSON.stringify({})

        return JSON.parse(stored)?.client ? true : false
    })
    const [entityIsFiltered, setEntityIsFiltered] = useState(() => {
        const stored = localStorage.getItem("requestFilters") ?? JSON.stringify({})

        return JSON.parse(stored)?.entity ? true : false
    })
    const [industryIsFiltered, setIndustryIsFiltered] = useState(() => {
        const stored = localStorage.getItem("requestFilters") ?? JSON.stringify({})

        return JSON.parse(stored)?.industry ? true : false
    })
    const [statusIsFiltered, setStatusIsFiltered] = useState(() => {
        const stored = localStorage.getItem("requestFilters") ?? JSON.stringify({})

        return JSON.parse(stored)?.status ? true : false
    })
    const [locationIsFiltered, setLocationIsFiltered] = useState(() => {
        const stored = localStorage.getItem("requestFilters") ?? JSON.stringify({})

        return JSON.parse(stored)?.location ? true : false
    })

    // VARIABLES TO FILTER DATA
    const [clientFilterApplied, setClientFilterApplied] = useState(() => {
        if (clientIsFiltered) return clientFilter

        return []
    })

    const [entityFilterApplied, setEntityFilterApplied] = useState(() => {
        if (entityIsFiltered) return entityFilter

        return []
    })
    const [industryFilterApplied, setIndustryFilterApplied] = useState(() => {
        if (industryIsFiltered) return industryFilter

        return []
    })
    const [statusFilterApplied, setStatusFilterApplied] = useState(() => {
        if (statusIsFiltered) return statusFilter

        return []
    })
    const [locationFilterApplied, setLocationFilterApplied] = useState(() => {
        if (locationIsFiltered) return locationFilter

        return []
    })

    //VARIABLE TO SHOW RESET ALL FILTERS
    const [resetAll, setResetAll] = useState(false)

    // VARIABLE TO CONTROL GLOBAL SEARCH
    const [searchValue, setSearchValue] = useState(() => {
        const stored = localStorage.getItem("requestFilters")

        return paramsCompanyName ?? JSON.parse(stored)?.searchValue ?? ""
    })
    const [applySearchFilter, setApplySearchFilter] = useState(searchValue)

    const [industrySearch, setIndustrySearch] = useState("")
    const [locationSearch, setLocationSearch] = useState("")

    const [openFilter, setOpenFilter] = useState(null)

    const [suppliersRequestData, setSuppliersRequestData] = useState({})
    // Cache local para data de tabla: { cacheKey: data }
    const [cache, setCache] = useState({})
    const [filtersData, setFiltersData] = useState({})

    //VARIABLES TO CONTROL MODAL
    const [supplierID, setSupplierID] = useState(null)
    const [showModal, setShowModal] = useState(false)
    const [supplierClientID, setSupplierClientID] = useState(null)
    const [supplierClients, setSupplierClients] = useState([])

    const [showMassiveModal, setShowMassiveModal] = useState(false)

    // VARIABLE TO NAVIGATE
    const navigate = useNavigate();

    const mainStyle = {
        background: darkLightMode ? "#131E29" : "white",
        color: darkLightMode ? "white" : "inherit"
    }

    const getFilters = useCallback(async ({ signal }) => {
        try {
            const query = new URLSearchParams();
            query.append("rol", userLogged?.rol);
            query.append("clientID", userLogged?.dataID);
            query.append("isForRequests", true)

            const { data } = await axios.get(`${URI_SUPPLIERS_FILTERS}?${query.toString()}`, { signal });

            setFiltersData(data)
        } catch (error) {
            if (error.name === "AbortError") return
            
            const errorMessage = error.response?.data?.message || "An error occurred while fetching filters.";
            console.error("Error fetching filters: ", errorMessage);
        }
    }, [userLogged])
    
    // Construir cacheKey igual que en getSuppliersRequest
    const cacheKey = useMemo(() => {
        return [
            applySearchFilter,
            orderBy + ':' + order,
            'page:' + currentPage,
            'limit:' + itemsPerPage,
            'client:' + clientFilterApplied.join(','),
            'entity:' + entityFilterApplied.join(','),
            'industry:' + industryFilterApplied.join(','),
            'status:' + statusFilterApplied.join(','),
            'location:' + locationFilterApplied.join(','),
            'cvp:' + cvpFilter
        ].join('__');
    }, [applySearchFilter, orderBy, order, currentPage, clientFilterApplied, entityFilterApplied, industryFilterApplied, statusFilterApplied, locationFilterApplied, cvpFilter]);
    
    const getSuppliersRequest = useCallback(async ({ 
        userLogged,
        signal = undefined,
        search = "", 
        order = "ASC", 
        orderBy = "companyName", 
        page = 1, 
        limit = itemsPerPage,
        clientFilterApplied = [],
        entityFilterApplied = [],
        industryFilterApplied = [],
        statusFilterApplied = [],
        locationFilterApplied = [],
        cvpFilterApplied = false
    }) => {
        try {
            const query = new URLSearchParams({
                rol: userLogged?.rol,
                clientID: userLogged?.dataID,
                search: search,
                order: order,
                orderBy: orderBy,
                page: page,
                limit: limit,
                isForRequests: true
            });

            if (clientFilterApplied.length > 0) clientFilterApplied.forEach(val => query.append("clientFilterApplied[]", val));
            if (entityFilterApplied.length > 0) entityFilterApplied.forEach(val => query.append("entityFilterApplied[]", val));
            if (industryFilterApplied.length > 0) industryFilterApplied.forEach(val => query.append("industryFilterApplied[]", val));
            if (statusFilterApplied.length > 0) statusFilterApplied.forEach(val => query.append("statusFilterApplied[]", val));
            if (locationFilterApplied.length > 0) locationFilterApplied.forEach(val => query.append("locationFilterApplied[]", val));
            if (cvpFilterApplied) query.append("cvpFilterApplied", cvpFilterApplied);

            Swal.fire({
                footer: 'Loading, please wait',
                showConfirmButton: false,
                allowOutsideClick: false,
                allowEscapeKey: false,
                didOpen: () => {
                    Swal.showLoading()
                },
            })

            const { data } = await axios.get(`${URI_SUPPLIERS_REQUESTS}?${query.toString()}`, { signal });

            // Guardar respuesta completa en cache local
            setCache(prev => ({ ...prev, [cacheKey]: data }));
            setSuppliersRequestData(data);

            Swal.close()
        } catch (error) {
            if (error.name === "AbortError") return;
            
            const errorMessage = error.response?.data?.message || "An error occurred while fetching supplier requests.";
            
            console.error("Error fetching supplier requests: ", errorMessage);

            Swal.fire({
                icon: 'error',
                text: 'Failed to get suppliers requests',
                showConfirmButton: false,
                timer: 5000,
                timerProgressBar: true,
            })
        }
    }, [cacheKey]);

    useEffect(() => {
        const controller = new AbortController();

        const { signal } = controller;

        if (!userLogged) return

        getFilters({ signal })
    }, [userLogged, getFilters])

    useEffect(() => {
        const controller = new AbortController();
        const { signal } = controller;

        if (!userLogged) return;

        if (cache[cacheKey]) {
            setSuppliersRequestData(cache[cacheKey]);
            return () => controller.abort();
        } else {
            const handler = setTimeout(() => {
                getSuppliersRequest({
                    userLogged,
                    signal,
                    search: applySearchFilter, 
                    orderBy, 
                    order, 
                    page: currentPage, 
                    limit: itemsPerPage,
                    clientFilterApplied,
                    entityFilterApplied,
                    industryFilterApplied,
                    statusFilterApplied,
                    locationFilterApplied,
                    cvpFilterApplied: cvpFilter
                })
            }, 300)

            return () => {
                clearTimeout(handler);
                controller.abort();
            }
        }
    }, [userLogged, getSuppliersRequest, applySearchFilter, orderBy, order, currentPage, clientFilterApplied, entityFilterApplied, industryFilterApplied, statusFilterApplied, locationFilterApplied, cvpFilter, cache, cacheKey]);
    
    // useEffect to add body listener
    useEffect(() => {
        window.onbeforeunload = clearSessionStorage;

        document.body.addEventListener("mousedown", closeMenusFilters)

        return function cleanUp() {
            window.onbeforeunload = null; // Cleanup event listener
            document.body.removeEventListener("mousedown", closeMenusFilters)
        }
    }, [])

    // COMPARATION TO SHOW THE RESET ALL BUTTON
    useEffect(() => {
        if (clientIsFiltered || entityIsFiltered || industryIsFiltered || statusIsFiltered || locationIsFiltered || cvpFilter) {
            setResetAll(true)
        } else {
            setResetAll(false)
        }
    }, [clientIsFiltered, entityIsFiltered, industryIsFiltered, statusIsFiltered, locationIsFiltered, cvpFilter])

    // CLEAR SESSION STORAGE ON PAGE REFRESH
    const clearSessionStorage = () => {
        sessionStorage.removeItem('currentPageRequest');
    };

    // FUNCTION TO CLOSE MENU FILTERS
    const closeMenusFilters = (e) => {
        if (!filterRef?.current?.contains(e.target)) {
            setOpenFilter(null)
        }

        if (!sortMenuRef?.current?.contains(e.target)) {
            setShowSortMenu(false)
        }
    }

    const handleOpenFilter = (e, filterName) => {
        filterRef.current = e.target

        setOpenFilter(prev => {
            if (prev === filterName) return null

            return filterName
        })
    }

    // FUNCTION TO SORT TABLE COLUMN
    const sortTable = (order, sortBy) => {
        setOrder(order)
        setOrderBy(sortBy)
    }

    // FUNCTIONS TO ADD FILTERS
    const toggleFilterValue = (setFilter) => (target) => {
        setFilter(prev => {
            const existValue = prev.some(valueToFind => valueToFind === target.value);

            if (existValue) {
                return prev.filter(valueToFind => valueToFind !== target.value);
            }

            return [...prev, target.value];
        });
    };

    const handleCvp = (value) => {
        const prevFilters = JSON.parse(localStorage.getItem("requestFilters") ?? "{}")
        let saveFilters = {}

        saveFilters = {
            ...prevFilters,
            cvp: value
        }

        setCvpFilter(value)

        localStorage.setItem("requestFilters", JSON.stringify(saveFilters))
    }

    // FUNCTIONS TO DISPLAY THE MODAL
    const activateModal = (supplier, clientID) => {
        setSupplierID(supplier.supplierID)
        setShowModal(true)
        setSupplierClientID(clientID)

        switch (userLogged?.rol) {
            case "Master":
            case "Super admin":
                setSupplierClients(supplier.clients)
                break;
        
            case "Admin client":
            case "Admin Compliance manager":
                const client = filtersData?.clientsFilter?.find(c => c._id === userLogged.dataID)
                const entitiesIds = client.entities.map(entity => entity._id)
                setSupplierClients(supplier.clients.filter(client => entitiesIds.includes(client.entityID)))
                break;
            case "Client":
            case "Compliance manager":
                setSupplierClients(supplier.clients.filter(client => client.clientID.toString() === userLogged.dataID))
                break;
            default:
                break;
        }
    }

    const handleCloseModal = () => {
        setShowModal(false)
        getSuppliersRequest({
            userLogged,
            search: applySearchFilter, 
            orderBy, 
            order, 
            page: currentPage, 
            limit: itemsPerPage,
            clientFilterApplied,
            entityFilterApplied,
            industryFilterApplied,
            statusFilterApplied,
            locationFilterApplied,
            cvpFilterApplied: cvpFilter
        })
    }

    const handleCloseMassiveModal = () => {
        setShowMassiveModal(false)
        getSuppliersRequest({
            userLogged,
            search: applySearchFilter, 
            orderBy, 
            order, 
            page: currentPage, 
            limit: itemsPerPage,
            clientFilterApplied,
            entityFilterApplied,
            industryFilterApplied,
            statusFilterApplied,
            locationFilterApplied,
            cvpFilterApplied: cvpFilter
        })
    }

    // FUNTION TO GET THE TABLE REPORT
    const getTableReport = () => {
        Swal.fire({
            footer: 'Loading, please wait',
            showConfirmButton: false,
            allowOutsideClick: false,
            allowEscapeKey: false,
            didOpen: () => {
                Swal.showLoading()
            },
        })

        axios.post(URI_REPORT_SUPPLIER_REQUEST, {
            userLogged: userLogged,
            isForRequests: true,
            filters: {
                clientFilter: clientFilter,
                entityFilter: entityFilter,
                industryFilter: industryFilter,
                statusFilter: statusFilter,
                locationFilter: locationFilter,
                cvpFilter: cvpFilter
            }
        }).then(response => {
            Swal.fire({
                icon: 'success',
                text: `${response.data.message}`,
                showConfirmButton: false,
                timer: 5000,
                timerProgressBar: true,
            })

            window.open(URI_UPLOADS + response.data.path, "_blank")
        }).catch(err => {
            Swal.fire({
                icon: 'error',
                text: 'Failed to generate the report',
                showConfirmButton: false,
                timer: 5000,
                timerProgressBar: true,
            })
        })
    }

    // FUNCTION TO FILTER THE SUPPLIER REQUEST BY INPUT SEARCH
    const searchFilter = (value) => {
        setSearchValue(value)

        // SAVE VALUE IN LOCAL STORAGE
        const searchValueToLocal = {
            searchValue: value
        }

        localStorage.setItem("requestFilters", JSON.stringify(searchValueToLocal))

        setCurrentPage(1)
    }

    const applyFilter = (filterToApply) => {
        setSearchValue("")
        setApplySearchFilter("")
        const prevFilters = JSON.parse(localStorage.getItem("requestFilters") ?? "{}")
        if (prevFilters.hasOwnProperty("searchValue")) {
            delete prevFilters.searchValue;
        }
        let saveFilters = {}
        
        switch (filterToApply) {
            case "client": {
                if (clientFilter.length > 0) {
                    setClientIsFiltered(true)
                    setClientFilterApplied(clientFilter)
                    setEntityFilter([])
                    setEntityIsFiltered(false)
                    setEntityFilterApplied([])

                    saveFilters = {
                        ...prevFilters,
                        client: clientFilter
                    }

                }

                break;
            }

            case "entity": {
                if (entityFilter.length > 0) {
                    setEntityIsFiltered(true)
                    setEntityFilterApplied(entityFilter)

                    saveFilters = {
                        ...prevFilters,
                        entity: entityFilter
                    }
                }

                break;
            }

            case "industry": {
                if (industryFilter.length > 0) {
                    setIndustryIsFiltered(true)
                    setIndustryFilterApplied(industryFilter)
                    saveFilters = {
                        ...prevFilters,
                        industry: industryFilter
                    }
                }

                break;
            }

            case "status": {
                if (statusFilter.length > 0) {
                    setStatusIsFiltered(true)
                    setStatusFilterApplied(statusFilter)
                    saveFilters = {
                        ...prevFilters,
                        status: statusFilter
                    }
                }

                break;
            }

            case "location": {
                if (locationFilter.length > 0) {
                    setLocationIsFiltered(true)
                    setLocationFilterApplied(locationFilter)
                    saveFilters = {
                        ...prevFilters,
                        location: locationFilter
                    }
                }

                break;
            }

            default:
                break;
        }

        localStorage.setItem("requestFilters", JSON.stringify(saveFilters))
    }

    // FUNCTION TO CLEAR THE SUPPLIER REQUEST BY FILTER BUTTONS AND RESET ALL ON DEFAULT CASE
    const clearFilter = (filter) => {
        let savedFilters = JSON.parse(localStorage.getItem("requestFilters") ?? "{}")
        
        switch (filter) {
            case "client":
                setClientFilter([])
                setClientIsFiltered(false)
                if (clientFilterApplied.length > 0) setClientFilterApplied([]) 

                setEntityFilter([])
                setEntityIsFiltered(false)
                if (entityFilterApplied.length > 0) setEntityFilterApplied([])

                if (savedFilters.hasOwnProperty("client")) {
                    delete savedFilters.client;
                }

                if (savedFilters.hasOwnProperty("entity")) {
                    delete savedFilters.entity;
                }
                break;

            case "entity":
                setEntityFilter([])
                setEntityIsFiltered(false)
                if(entityFilterApplied.length > 0) setEntityFilterApplied([])
                if (savedFilters.hasOwnProperty("entity")) {
                    delete savedFilters.entity;
                }
                break;

            case "industry":
                setIndustryFilter([])
                setIndustryIsFiltered(false)
                if (industryFilterApplied.length > 0) setIndustryFilterApplied([])
                if (savedFilters.hasOwnProperty("industry")) {
                    delete savedFilters.industry;
                }

                break;

            case "status":
                setStatusFilter([])
                setStatusIsFiltered(false)
                if (statusFilterApplied.length > 0) setStatusFilterApplied([])
                if (savedFilters.hasOwnProperty("status")) {
                    delete savedFilters.status;
                }
                break;

            case "location":
                setLocationFilter([])
                setLocationIsFiltered(false)
                if (locationFilterApplied.length > 0) setLocationFilterApplied([])
                if (savedFilters.hasOwnProperty("location")) {
                    delete savedFilters.location;
                }
                break;

            case "all": {
                setClientFilter([])
                setClientIsFiltered(false)
                setClientFilterApplied([])

                setEntityFilter([])
                setEntityIsFiltered(false)
                setEntityFilterApplied([])

                setIndustryFilter([])
                setIndustryIsFiltered(false)
                setIndustryFilterApplied([])

                setStatusFilter([])
                setStatusIsFiltered(false)
                setStatusFilterApplied([])

                setLocationFilter([])
                setLocationIsFiltered(false)
                setLocationFilterApplied([])

                setCvpFilter(false)

                localStorage.removeItem("requestFilters")
                
                break;
            }

            default:
                break;
        }

        if (filter !== "all") localStorage.setItem("requestFilters", JSON.stringify(savedFilters))
    }

    // FUNCTION TO CREATE THE ENTITY LIST TO SHOW ON FILTER BUTTON
    const createEntityFilter = () => {
        let filterEntity

        switch (userLogged?.rol) {
            case "Master":
            case "Super admin":
                filterEntity = new Set(filtersData?.clientsFilter?.filter(client => {
                    return clientFilter.includes(client._id)
                }).flatMap(client => client.entities.map(entity => entity)))

                return Array.from(filterEntity).sort()

            case "Admin client":
            case "Admin Compliance manager":
                filterEntity = new Set(filtersData?.clientsFilter?.filter(client => {
                    return userLogged.dataID === client._id
                }).flatMap(client => client.entities.map(entity => entity)))

                return Array.from(filterEntity).sort()

            default:
                break;
        }
    }

    const handleSupplierOnClick = (supplier) => {
        switch (userLogged?.rol) {
            case "Master":
            case "Super admin":
                supplier.clients.every(c => c.status === "New request") ? activateModal(supplier, supplier.clients[0]?.clientID) : navigate("./reviewForAuth/" + supplier.supplierID)
                break;
        
            case "Admin client":
            case "Admin Compliance manager":
                const client = filtersData?.clientsFilter?.find(c => c._id === userLogged.dataID)
                const entitiesIds = client.entities.map(entity => entity._id)
                const clientsFiltered = supplier.clients.filter(c => entitiesIds.includes(c.clientID))

                clientsFiltered.every(c => c.status === "New request") ? activateModal(supplier, clientsFiltered[0]?.clientID) : navigate("./reviewForAuth/" + supplier.supplierID)

                break;

            case "Client":
            case "Compliance manager": {
                const clientsFiltered = supplier.clients.filter(c => c.clientID === userLogged.dataID)
                clientsFiltered.every(c => c.status === "New request") ? activateModal(supplier, clientsFiltered[0]?.clientID) : navigate("./reviewForAuth/" + supplier.supplierID)
            }
                
                break;
            default:
                break;
        }
    }

    const totalPagesFinal = Math.ceil((suppliersRequestData?.total ?? 1) / itemsPerPage)

    function paginate(pageNumber) {
        if (pageNumber < 1 || pageNumber > totalPagesFinal) return;
        
        sessionStorage.setItem("currentPageRequest", pageNumber);
        setCurrentPage(pageNumber);
    }

    const tableCount = useMemo(() => itemsPerPage * currentPage > suppliersRequestData?.total ? suppliersRequestData?.total : itemsPerPage * currentPage, [currentPage, suppliersRequestData?.total]);

    const handleSetSearchFilterValue = (e) => {
        e.preventDefault();
        
        if (clientIsFiltered || 
            entityIsFiltered || 
            industryIsFiltered || 
            statusIsFiltered || 
            locationIsFiltered || 
            cvpFilter
        ) {
            clearFilter("all")
        }
        
        setApplySearchFilter(searchValue);
    }

    return (
        <section className={`request ${darkLightMode ? "darkMode" : null}`}>
            <div className="titleAndSearch">
                <h3 className="title">Supplier Requests</h3>
                <div className="searchAndSort">
                    <form onSubmit={handleSetSearchFilterValue}>
                        <div className={`searchContainer ${darkLightMode ? "darkMode" : null}`}>
                            <input id="generalSearch" type="text" placeholder="Search by name..."
                                onChange={(e) => searchFilter(e.target.value)} value={searchValue} />

                            <button className='applySearchButton' type="submit"></button>
                        </div>
                    </form>
                    <button ref={sortMenuRef} className="d-lg-none sortMobile" onClick={() => setShowSortMenu(true)}>Sort</button>
                    <div className={`d-lg-none sortDataContainer ${showSortMenu ? "show" : ""}`}>
                        <h5 className="title">Sort</h5>
                        <span onClick={() => { sortTable("ASC", "companyName") }}>Name (ascending)</span>
                        <span onClick={() => { sortTable("DSC", "companyName") }}>Name (descending)</span>
                        <span onClick={() => { sortTable("ASC", "industries") }}>Industry (ascending)</span>
                        <span onClick={() => { sortTable("DSC", "industries") }}>Industry (descending)</span>
                        <span onClick={() => { sortTable("ASC", "location") }}>Location (ascending)</span>
                        <span onClick={() => { sortTable("DSC", "location") }}>Location (descending)</span>
                        <span onClick={() => { sortTable("ASC", "date") }}>Date (ascending)</span>
                        <span onClick={() => { sortTable("DSC", "date") }}>Date (descending)</span>
                    </div>
                </div>
            </div>
            <div className="filters">
                {(userLogged?.rol === "Master" || userLogged?.rol === "Super admin") &&
                    <div className={`filter ${openFilter === "client" ? "show" : null} ${darkLightMode ? "darkMode" : null} ${clientIsFiltered ? "active" : undefined}`} onClick={(e) => handleOpenFilter(e, "client")}>
                        <img src={client} alt="Prodensa Supplier" />
                        <span>Client</span>
                        <div className={`filterOptions ${openFilter === "client" ? "show" : null}`} onClick={(e) => !e.target.matches("button") && e.stopPropagation()}>
                            <img src={close} alt="Prodensa Supplier" className="closeImg d-lg-none" onClick={() => setOpenFilter(null)} />
                            <span className="title">
                                <img className="d-lg-none imgMenu" src={client} alt="Prodensa Supplier" />
                                Client
                            </span>
                            <div className="optionsScroll">
                                {filtersData?.clientsFilter?.map(client => {
                                    if (client.generalInformation.clientName === "Admin Prodensa") return null

                                    return (
                                        <div key={`filter-${client._id}`} className="option">
                                            <input checked={clientFilter.includes(client._id?.toString())} className="clientCheck" value={client._id} type="checkbox" id={`item-${client._id}`} onChange={(e) => toggleFilterValue(setClientFilter)(e.target)} />
                                            <label htmlFor={`item-${client._id}`}>{client.generalInformation.clientName}</label>
                                        </div>
                                    )
                                })}
                            </div>
                            <div className="actions">
                                <button onClick={() => clearFilter("client")}>Clear</button>
                                <button onClick={() => applyFilter("client")}>Apply</button>
                            </div>
                        </div>
                    </div>}
                {(clientIsFiltered || userLogged?.rol === "Admin client" || userLogged?.rol === "Admin Compliance manager") &&
                    <div className={`filter ${openFilter === "entity" ? "show" : null} ${darkLightMode ? "darkMode" : null} ${entityIsFiltered ? "active" : undefined}`} onClick={(e) => handleOpenFilter(e, "entity")}>
                        <img src={client} alt="Prodensa Supplier" />
                        <span>Entity</span>
                        <div className={`filterOptions ${openFilter === "entity" ? "show" : null}`} onClick={(e) => !e.target.matches("button") && e.stopPropagation()}>
                            <img src={close} alt="Prodensa Supplier" className="closeImg d-lg-none" onClick={() => setOpenFilter(null)} />
                            <span className="title">
                                <img className="d-lg-none imgMenu" src={client} alt="Prodensa Supplier" />
                                Entity
                            </span>
                            <div className="optionsScroll">
                                {createEntityFilter()?.map((entity, index) => {
                                    return (
                                        <div key={index} className="option">
                                            <input checked={entityFilter.includes(entity._id?.toString())} className="entityCheck" value={entity._id} type="checkbox" id={`entity${index}`} onChange={(e) => toggleFilterValue(setEntityFilter)(e.target)} />
                                            <label htmlFor={`entity${index}`} >{entity.entityName}</label>
                                        </div>
                                    )
                                })}
                            </div>
                            <div className="actions">
                                <button onClick={() => clearFilter("entity")}>Clear</button>
                                <button onClick={() => applyFilter("entity")}>Apply</button>
                            </div>
                        </div>
                    </div>}
                <div className={`filter ${openFilter === "industry" ? "show" : null} ${darkLightMode ? "darkMode" : null} ${industryIsFiltered ? "active" : undefined}`} onClick={(e) => handleOpenFilter(e, "industry")}>
                    <img src={industry} alt="Prodensa Supplier" />
                    <span>Industry</span>
                    <div className={`searchContainer ${openFilter === "industry" ? "show" : null}`} onClick={(e) => e.stopPropagation()}>
                        <input value={industrySearch} type="text" placeholder="Search industries"
                            onChange={(e) => setIndustrySearch(e.target.value)} />
                    </div>
                    <div className={`filterOptions location ${openFilter === "industry" ? "show" : null}`} onClick={(e) => !e.target.matches("button") && e.stopPropagation()}>
                        <img src={close} alt="Prodensa Supplier" className="closeImg d-lg-none" onClick={() => setOpenFilter(null)} />
                        <span className="title">
                            <img className="d-lg-none imgMenu" src={industry} alt="Prodensa Supplier" />
                            Industry
                        </span>
                        <div className="optionsScroll">
                            {filtersData?.industriesFilter?.map((industry, index) => {
                                return (
                                    <div key={index} className="option">
                                        <input checked={industryFilter.includes(industry)} className="industryCheck" value={industry} type="checkbox" id={`industry${index}`} onChange={(e) => toggleFilterValue(setIndustryFilter)(e.target)} />
                                        <label htmlFor={`industry${index}`} >{industry}</label>
                                    </div>
                                )
                            })}
                        </div>
                        <div className="actions">
                            <button onClick={() => clearFilter("industry")}>Clear</button>
                            <button onClick={() => applyFilter("industry")}>Apply</button>
                        </div>
                    </div>
                </div>
                <div className={`filter ${openFilter === "status" ? "show" : null} ${darkLightMode ? "darkMode" : null} ${statusIsFiltered ? "active" : undefined}`} onClick={(e) => handleOpenFilter(e, "status")}>
                    <img src={status} alt="Prodensa Supplier" />
                    <span>Status</span>
                    <div className={`filterOptions ${openFilter === "status" ? "show" : null}`} onClick={(e) => !e.target.matches("button") && e.stopPropagation()}>
                        <img src={close} alt="Prodensa Supplier" className="closeImg d-lg-none" onClick={() => setOpenFilter(null)} />
                        <span className="title">
                            <img className="d-lg-none imgMenu" src={status} alt="Prodensa Supplier" />
                            Status
                        </span>
                        <div className="optionsScroll">
                            {statusFilterArray.map((filter, index) => (
                                <div key={index} className="option">
                                    <input checked={statusFilter.includes(filter)} className="statusCheck" value={filter} type="checkbox" id={`status${index}`} onChange={(e) => toggleFilterValue(setStatusFilter)(e.target)} />
                                    <label htmlFor={`status${index}`}>{filter}</label>
                                </div>
                            ))}
                        </div>
                        <div className="actions">
                            <button onClick={() => clearFilter("status")}>Clear</button>
                            <button onClick={() => applyFilter("status")}>Apply</button>
                        </div>
                    </div>
                </div>
                <div className={`filter ${openFilter === "location" ? "show" : null} ${darkLightMode ? "darkMode" : null} location ${locationIsFiltered ? "active" : undefined}`} onClick={(e) => handleOpenFilter(e, "location")}>
                    <img src={locationImg} alt="Prodensa Supplier" />
                    <span>Location</span>
                    <div className={`searchContainer ${openFilter === "location" ? "show" : null}`} onClick={(e) => e.stopPropagation()}>
                        <input value={locationSearch} type="text" placeholder="Search cities"
                            onChange={(e) => setLocationSearch(e.target.value)} />
                    </div>
                    <div className={`filterOptions location ${openFilter === "location" ? "show" : null}`} onClick={(e) => !e.target.matches("button") && e.stopPropagation()}>
                        <img src={close} alt="Prodensa Supplier" className="closeImg d-lg-none" onClick={() => setOpenFilter(null)} />
                        <span className="title">
                            <img className="d-lg-none imgMenu" src={locationImg} alt="Prodensa Supplier" />
                            Location
                        </span>
                        <div className="optionsScroll">
                            {filtersData?.locationFilter?.filter(item => !locationSearch || item.toLocaleLowerCase().includes(locationSearch.toLocaleLowerCase())).map((filter, index) => (
                                <div key={index} className="option">
                                    <input checked={locationFilter.includes(filter)} className="locationCheck" value={filter} type="checkbox" id={`location${index}`} onChange={(e) => toggleFilterValue(setLocationFilter)(e.target)} />
                                    <label htmlFor={`location${index}`} >{filter}</label>
                                </div>
                            ))}
                        </div>
                        <div className="actions">
                            <button onClick={() => clearFilter("location")}>Clear</button>
                            <button onClick={() => applyFilter("location")}>Apply</button>
                        </div>
                    </div>
                </div>
                <div className={`checkboxFilter ${darkLightMode ? "darkMode" : ""}`}>
                    <img src={certifications} alt="Prodensa Supplier" />

                    <label htmlFor="cvpCheckbox">CVP</label>

                    <input type="checkbox" id="cvpCheckbox" checked={cvpFilter} onChange={() => handleCvp(!cvpFilter)} />
                </div>
                <span className={`resetAll ${resetAll ? "show" : ""}`} onClick={() => clearFilter("all")}>Reset All</span>
                <button className="btnBgBlueTextGradient ms-lg-auto" onClick={() => setShowMassiveModal(true)}>
                    Massive assignment
                </button>
            </div>
            <div className="newRequestActions">
                <button className="btnBgBlueTextGradient d-lg-none" onClick={() => setShowMassiveModal(true)}>
                    Massive assignment
                </button>
            </div>
            <span className={`resetAll ${resetAll ? "show" : ""} d-lg-none`} onClick={() => clearFilter("all")}>Reset All</span>

            <table className="tableRequests">
                <thead>
                    <tr>
                        <th style={mainStyle}>
                            <span>Name</span>
                            <img className="sort" src={sortIcon} alt="Prodensa supplier" onClick={() => sortTable(order === "ASC" ? "DSC" : "ASC", "companyName")} />
                        </th>
                        <th style={mainStyle}>
                            <span>Industry</span>
                            <img className="sort" src={sortIcon} alt="Prodensa supplier" onClick={() => sortTable(order === "ASC" ? "DSC" : "ASC", "industries")} />
                        </th>
                        <th style={mainStyle}>
                            <span>Location</span>
                            <img className="sort" src={sortIcon} alt="Prodensa supplier" onClick={() => sortTable(order === "ASC" ? "DSC" : "ASC", "location")} />
                        </th>
                        <th style={mainStyle}>
                            <span>Date</span>
                            <img className="sort" src={sortIcon} alt="Prodensa supplier" onClick={() => sortTable(order === "ASC" ? "DSC" : "ASC", "date")} />
                            <img className="printReport" src={printReport} alt="Prodensa supplier" onClick={() => getTableReport()} />
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {suppliersRequestData?.suppliers?.map((supplier, index) => (
                        <tr key={index}>
                            <td>
                                <div className={`infoContainer ${supplier.certified ? "withBadge" : ""}`}>
                                    {supplier.certified && <img className="cvpBadge" src={cvpBadge} alt="Prodensa Cattenna" />}
                                    <span onClick={() => handleSupplierOnClick(supplier)}>
                                        {supplier.companyName}
                                    </span>
                                </div>
                            </td>
                            <td>
                                <div className="infoContainer">
                                    <span>{supplier.industries.map((industry, index) => {
                                        return supplier.industries.length > index + 1 ? industry + ", " : industry
                                    })}</span>
                                </div>
                            </td>
                            <td>
                                <div className="infoContainer">
                                    <span>{supplier.location}</span>
                                </div>
                            </td>
                            <td>
                                <div className="infoContainer">
                                    <span>{moment(supplier.updatedAt).format("DD MMM YYYY")}</span>
                                    <img className="viewProfile" src={viewProfile} alt="Prodensa Supplier" onClick={() => handleSupplierOnClick(supplier)} />
                                </div>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>

            <div className="d-lg-none supplierRequests">
                {suppliersRequestData?.suppliers?.map((supplier, index) => (
                    <div key={index} className="requestRow" onClick={() => handleSupplierOnClick(supplier)}>
                        <div className="requestHeader">
                            {supplier.certified && <img className="cvpBadge" src={cvpBadge} alt="Prodensa Cattenna" />}
                            <h5 className="requestName">
                                {supplier.companyName}
                            </h5>
                        </div>
                        <div className="requestInformation">
                            <span className="requestValue">{supplier.location}</span>
                            <span className="requestTitle">Location</span>
                            <span className="requestValue">{supplier.industries.map((industry, index) => {
                                return supplier.industries.length > index + 1 ? industry + ", " : industry
                            })}</span>
                            <span className="requestTitle">Industry</span>
                            <span className="requestValue">{moment(supplier.updatedAt).format("DD MMM YYYY")}</span>
                            <span className="requestTitle">Date</span>
                        </div>
                    </div>
                ))}
            </div>

            <PageSelector 
                className="suppliersTablePagination"
                currentPage={currentPage ?? 1}
                totalItems={suppliersRequestData?.total ?? 0}
                itemsPerPage={itemsPerPage}
                onChange={paginate}
            />
            <span className="tableCount">{tableCount} of {suppliersRequestData?.total ?? 1}</span>

            {supplierID && supplierClientID && 
                <NewRequestModal 
                    darkLightMode={darkLightMode}
                    show={showModal} 
                    userLogged={userLogged} 
                    supplierID={supplierID} 
                    handleClose={() => handleCloseModal()} 
                    supplierClientID={supplierClientID} 
                    setSupplierClientID={setSupplierClientID} 
                    supplierClients={supplierClients} />
            }

            <MassiveStatusUpdateModal show={showMassiveModal} handleClose={handleCloseMassiveModal} />
        </section>
    )
}